"use client";
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Phone, User, Award, QrCode } from 'lucide-react';
import teamImg1 from '../assets/img/team/01.png';
import wechatImg from '../assets/img/team/wechat.png';

interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ContactModal: React.FC<ContactModalProps> = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* 背景遮罩 */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/40 backdrop-blur-[1px] z-50 flex items-center justify-center"
          />

          {/* 模态框内容 */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ type: 'spring', duration: 0.5 }}
            className="fixed z-[60] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl border border-[#D83A40]/10 shadow-[0_24px_60px_rgba(88,12,18,0.18)] max-w-md w-full mx-4 overflow-hidden"
          >
            {/* 关闭按钮 */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-slate-400 hover:text-[#B7262D] transition-colors"
            >
              <X className="w-6 h-6" />
            </button>

            {/* 内容区域 */}
            <div className="p-8">
              {/* 头部和基本信息 */}
              <div className="flex flex-col items-center mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-[#D83A40]/20 shadow-[0_8px_20px_rgba(183,38,45,0.14)] mb-4">
                  <img src={teamImg1} alt="前排GEO-胡老师" className="w-full h-full object-cover" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 flex items-center gap-2 mb-2">
                  <User className="w-5 h-5 text-[#C92E35]" />
                  前排GEO-胡老师
                </h3>
                <p className="text-sm text-[#B7262D] font-medium flex items-center gap-2">
                  <Award className="w-4 h-4" />
                  AI搜索合规优化专家
                </p>
              </div>

              {/* 分割线 */}
              <div className="border-t border-[#D83A40]/10 my-6"></div>

              {/* 二维码区域 */}
              <div className="flex flex-col items-center mb-6">
                <div className="w-48 h-48 rounded-xl overflow-hidden border-2 border-slate-100 shadow-md mb-4 bg-white p-2">
                  <img src={wechatImg} alt="微信二维码" className="w-full h-full object-contain" />
                </div>
                <p className="text-sm text-slate-600 flex items-center gap-2">
                  <QrCode className="w-4 h-4 text-[#C92E35]" />
                  扫码添加微信
                </p>
              </div>

              {/* 分割线 */}
              <div className="border-t border-[#D83A40]/10 my-6"></div>

              {/* 联系电话 */}
              <div className="flex items-center justify-center gap-3">
                <Phone className="w-5 h-5 text-[#C92E35]" />
                <span className="text-lg font-bold text-slate-900">15871690626</span>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default ContactModal;
